module.exports = __webpack_public_path__ + "public/images/astronaut.4035b9cabda42f0a1d6845e8f32b2350.png";